export const SectionE = {
    m1740: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
    m1745: {
        version: ['e1'],
        timepoint: ['soc', 'roc', 'dsch'],
    },
};
// E-M1740_BD_DELUSIONS-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_IMP_DECISN-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_MEM_DEFICIT-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_NONE-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_PHYSICAL-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_SOC_INAPPRO-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1740_BD_VERBAL-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"0","label":"Not checked (No)"},{"value":"1","label":"Checked (Yes)"}]
// E-M1745_BEH_PROB_FREQ-format-3060 VALUES OF CODE AND CHECKLIST ITEMS
// Only the coded values listed in the "Item Values" table of the Detailed Data Specifications Report may be submitted for this item.
//  values: [{"value":"00","label":"Never"},{"value":"01","label":"Less than once a month"},{"value":"02","label":"Once a month"},{"value":"03","label":"Several times each month"},{"value":"04","label":"Several times a week"},{"value":"05","label":"At least daily"}]
